import React from "react";

function Input(props) {

    return(
        <input onChange={props.change} type={props.type} className="user" value={props.value} name={props.name} placeholder={props.placeholder}/>
    )
}

export default Input